const PAGE_SIZE = 20;

class TicketsController {
  constructor($state, $q, toaster, Ticket, Channel, Broadcast, $rootScope) {
    'ngInject';

    this.toaster = toaster;
    this.Ticket = Ticket;
    this.Channel = Channel;
    this.Broadcast = Broadcast;
    this.$q = $q;

    this.FeatureFlags = $rootScope.account.feature_flags;
    this.canReadTicketSummaries =
      $rootScope.user.can('read', 'broadcast/*:tickets:summary') &&
      $rootScope.user.can('read', 'channel/*:tickets:summary') &&
      $rootScope.user.can('read', 'tickets:summary');
    if (this.FeatureFlags.no_ticketed || !this.canReadTicketSummaries) {
      return;
    }

    this.report = $state.params.report;
    this.id = $state.params.id;
    this.account = $rootScope.account;
    this.timePeriod = null;
    this.loadingPromises = [];

    switch (this.report) {
      case 'broadcasts':
        this.reportName = 'Single Broadcast';
        if (this.id) {
          Broadcast.get({ id: this.id }, (obj) => (this.entity = obj));
          this.loadTicketsForPage(1);
        } else {
          this.loadBroadcastsForPage(1);
        }
        break;
      case 'channels':
        this.reportName = 'Channel';
        if (this.id) {
          Channel.get({ id: this.id }, (obj) => (this.entity = obj));
          this.loadTicketsForPage(1);
        } else {
          this.loadChannelsForPage(1);
        }
        break;
      case 'account':
        this.entity = this.account;
        if (this.id == 'channel') {
          this.reportName = 'All Channel Tickets';
        } else {
          this.reportName = 'All Broadcast Tickets';
        }
        this.loadTicketsForPage(1);
        break;
      default:
        this.loadGraph();
    }
  }

  loadGraph() {
    const { Ticket, $q } = this;

    const NUM_DAYS = 30;

    var start = moment().subtract(NUM_DAYS, 'day');
    var end = moment();
    var q = `created_at:[${start.toISOString()} TO ${end.toISOString()}]`;
    var p1 = Ticket.queryAll({ type: 'broadcast', l: 1000, s: '-created_at', q: q });
    var p2 = Ticket.queryAll({ type: 'channel', l: 1000, s: '-created_at', q: q });

    $q.all([p1, p2]).then((results) => {
      var tickets = results[0];
      var channelTickets = results[1];

      this.ticketsByDay = _.groupBy(tickets, (t) => moment(t.created_at).format('YYYY-MM-DD'));
      this.channelTicketsByDay = _.groupBy(channelTickets, (t) =>
        moment(t.created_at).format('YYYY-MM-DD')
      );

      this.ticketsGraphLabels = [];
      this.ticketsGraphTooltips = [];
      this.ticketsGraphData = [
        [], //daily count of broadcast tickets
        [], //daily count of channel tickets
      ];

      _.range(NUM_DAYS - 1, -1, -1).forEach((i) => {
        var dt = moment().clone().subtract(i, 'day');
        var dtf = dt.format('YYYY-MM-DD');
        this.ticketsGraphLabels.push(dt);
        this.ticketsGraphTooltips.push(`Tickets sold on ${dt.format('ddd MMM Do')}`);
        this.ticketsGraphData[0].push((this.ticketsByDay[dtf] || {}).length || 0);
        this.ticketsGraphData[1].push((this.channelTicketsByDay[dtf] || {}).length || 0);
      });

      this.ticketsGraphOptions = {
        legend: { display: false },
        scales: {
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM Do',
                },
              },
              //categoryPercentage: 0.20, //1 every 5 labels
              gridLines: { display: false },
              position: 'bottom',
              ticks: {
                fontSize: 11,
                fontFamily: 'Arial, sans-serif',
                //maxRotation: 0,
                autoSkip: true,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                min: 0,
                beginAtZero: true,
                suggestedMax: 10,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            title: (items, data) => {
              return this.ticketsGraphTooltips[items[0].index];
            },
          },
        },
      };
    });
  }

  loadBroadcastsForPage(p) {
    const { Broadcast, toaster } = this;
    var query = Broadcast.query(
      {
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-starts_at',
      },
      (data, headers) => {
        this.broadcasts = data;
        var pagination = JSON.parse(headers('x-pagination'));
        this.broadcastsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length,
        };
      },
      (err) => {
        toaster.pop('warning', 'Unable to load broadcasts. Please refresh the page and try again.');
      }
    );
    this.loadingPromises.push(query.$promise);
    if (p > 1) window.scrollTo(0, 0);
  }

  loadChannelsForPage(p) {
    const { Channel, toaster } = this;
    var query = Channel.query(
      {
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: 'name',
      },
      (data, headers) => {
        this.channels = data;
        var pagination = JSON.parse(headers('x-pagination'));
        this.channelsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length,
        };
      },
      (err) => {
        toaster.pop('warning', 'Unable to load channels. Please refresh the page and try again.');
      }
    );
    this.loadingPromises.push(query.$promise);
    if (p > 1) window.scrollTo(0, 0);
  }

  loadTicketsForPage(p) {
    const { Ticket, toaster } = this;
    var params = {
      resource: this.report,
      id: this.id,
    };
    if (params.resource == 'account') {
      params.type = this.id; //type=channel or type=broadcast passed as querystring
      delete params.resource;
      delete params.id;
    }
    if (this.start && this.end) {
      params.q = `created_at:[${this.start.toISOString()} TO ${this.end.toISOString()}]`;
    }
    var query = Ticket.query(
      angular.extend({}, params, {
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at',
      }),
      (data, headers) => {
        this.tickets = data;
        var pagination = JSON.parse(headers('x-pagination'));
        this.ticketsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length,
        };
      },
      (err) => {
        toaster.pop('warning', 'Unable to load tickets. Please refresh the page and try again.');
      }
    );

    this.summary = Ticket.summary(params);

    this.loadingPromises.push(query.$promise);
    this.loadingPromises.push(this.summary.$promise);

    if (p > 1) window.scrollTo(0, 0);
  }

  setTimePeriod(value) {
    // moment.month gives 0-11
    // we'll translate into quarter number 1-4
    var currentQuarterNumber = Math.ceil((moment().month() + 1) / 3);
    var startMonth = (currentQuarterNumber - 1) * 3;
    var endMonth = currentQuarterNumber * 3 - 1;

    if (value == 'this_q') {
      this.timePeriod = value;
      this.start = moment().month(startMonth).startOf('month').toDate();
      this.end = moment().month(endMonth).endOf('month').toDate();
    } else if (value == 'last_q') {
      this.timePeriod = value;
      this.start = moment().month(startMonth).subtract(3, 'months').startOf('month').toDate();
      this.end = moment().month(endMonth).subtract(3, 'months').endOf('month').toDate();
    } else {
      this.timePeriod = null;
      this.start = null;
      this.end = null;
    }
    this.loadTicketsForPage(1);
  }
}

export default TicketsController;



// WEBPACK FOOTER //
// ./app/pages/reports/tickets.js